const getCurrentStepNumber = ({ key }) => {
  switch (key) {
    case "VIOLATION_TYPE":
      return 1;
    case "RECEIVED_LETTER_TYPE":
      return 2;
    case "UPLOAD_DOCUMENTS":
      return 3;
    case "CONTACT_DETAILS":
      return 4;
    default:
      return null;
  }
};

export { getCurrentStepNumber };
